import type { ReactNode } from 'react';

/**
 * The firm's name as the header's text mark, for both forms (crossmarc/steward-app#1898).
 *
 * Below `lg` it may shrink and WRAPS onto a second line (steward-app#2509; it used to be cut with an
 * ellipsis, which hid the name), so a long name ("QA Onboarding Partners") stays clear of the save
 * dot and the "Section N of M" button. Two 20px lines at 1.1 leading fit the header's h-14.
 * `min-w-0` is what lets
 * a flex child shrink below its text, and `break-words` does the wrapping; a `shrink-0` here (the
 * intake header's old class) is what made the name run under its neighbours. From `lg` the
 * header has room and the name is shown whole.
 */
export function FirmWordmark({ children }: { children: ReactNode }) {
  return (
    <span className="min-w-0 break-words leading-[1.1] lg:shrink-0 font-display text-[20px] font-semibold uppercase tracking-[0.14em] text-navy">
      {children}
    </span>
  );
}
